/* eslint-disable */
import React, { useState, useEffect } from 'react'
import 'antd/dist/antd.css'
import { useDispatch } from 'react-redux'
import { Form, Input, Select, Cascader, Breadcrumb, Button, message, Spin } from 'antd';
import { CheckCircleFilled} from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import InputPrefix from 'helper/InputPrefix'
import { sendContact, getContactUs } from 'api/hub'
// import { useHistory } from 'react-router-dom'

const { TextArea } = Input;

const ContactUs= () => {
    const dispatch = useDispatch()
    const { t } = useTranslation()
    const { i18n } = useTranslation('ContactUs');
    const [form] = Form.useForm();
    // Dropdownlist List Language setting
    const [IndustryList, setIndustryList] = useState([""])
    const [data, setData] = useState(undefined)
    const [loading, setLoading] = useState(false)
    

    useEffect(()=>{
        setLoading(true)
        const tenant_id = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
        dispatch(getContactUs({parameter:tenant_id})).then(
            res => {
                console.log(res)
                setLoading(false)
                if (res.data) {
                    setIndustryList(res.data['industry_data_'+localStorage.getItem('lang')])
                    setData(res.data)
                    form.setFieldsValue({
                        "tenant_name": res.data['tenant_name_'+localStorage.getItem('lang')],
                        // "tenant_name_en": res.data.tenant.tenant_name_en,
               
                        "country": res.data.tenant_country,
    
    
                        // "first_name_p": res.data.contact_data[0].first_name,
                        // "last_name_p": res.data.contact_data[0].last_name,
                        // "position_p": res.data.contact_data[0].title,
                        // "mobile_phone_p": res.data.contact_data[0].mobile_num,
                        // "country_code_p": res.data.contact_data[0].country_code,
                        // "phone_p": res.data.contact_data[0].phone_num,
                        // "ext_number_p": res.data.contact_data[0].ext,
                        "Email_p": JSON.parse(localStorage.getItem('LoginInfo')).account,
                    })
                }
            }
        )
    },[])
    useEffect(()=>{
        console.log(data)
        if(data !== undefined){
            console.log(data)
            form.setFieldsValue({
                "tenant_name": data['tenant_name_'+i18n.language],
            })
            setIndustryList(data['industry_data_'+i18n.language])
        }

    },[i18n.language])
    const onFinish = (e) => {
        console.log(e, IndustryList)
        const tenant_id = JSON.parse(localStorage.getItem('LoginInfo')).tenantId
        const operator_id = JSON.parse(localStorage.getItem('LoginInfo')).operator_id
        setLoading(true)
        dispatch(sendContact({
            "tenant_id": tenant_id,
            "ip_address": "1.1.1.1",
            "operator_id": operator_id,
            "language": localStorage.getItem('lang'),
            "mail_data": {
              "subject": t('Contact.CustomerRequirements'),
              "mail_to": null,
              "content_json_data": {
                "service_id": null,
                "service_name": null,
                "vendor_id": null,
                "vendor_name": null,
                "tenant_id": tenant_id,
                "tenant_name": e.tenant_name,
                "industry_data": {
                  "industry_list": IndustryList
                },
                "last_name": e.last_name_p,
                "first_name": e.first_name_p,
                "title": e.position_p,
                "mobile_num": e.mobile_phone_p,
                "country_code": e.country_code_p,
                "phone_num": e.phone_p,
                "ext": e.ext_number_p,
                "email": e.Email_p,
                "mail_content": e.mail_content
              }
            }
          })).then(res=>{
            setLoading(false)
            console.log(res)
            if(res.code === 200){
                message.success({
                    content:t('Global.Success'),
                    className:"popupmessage"
                })
                window.location.reload()
            }
        })


    }
    
    return (
        <>
        <div className='innerlayout' style={{padding: "36px 0 0 130px"}}>
        <Spin tip={t('Global.Loading')} spinning={loading} >
            <Breadcrumb separator=">">
                <Breadcrumb.Item>WiAdvance App Market</Breadcrumb.Item>
                <Breadcrumb.Item>{t('Global.member_center')}</Breadcrumb.Item>
                <Breadcrumb.Item className='lastchild'>{t('Menu.ContactUs')}</Breadcrumb.Item>
            </Breadcrumb>
            <div className='headtitle'>
            {t('Menu.ContactUs')}
            </div>
            <div className='cinfotitle' style={{fontWeight: '600',fontSize: '22px', paddingTop:'30px'}}>
                <span style={{color:'#7DB926'}}>{t('Contact.CompanyInfo')}</span><span style={{paddingLeft:'20px', fontWeight: '400',fontSize: '16px',lineHeight: '28px',letterSpacing: '0.1em',color: '#7C7C7C'}}>{t('Contact.SignedAs')}({JSON.parse(localStorage.getItem('LoginInfo')).account}){t('Contact.Into')}</span>
            </div>
            <div className="registerlayout" style={{'margin':'30px 0px 0px 0px'}}>
            <div className={localStorage.getItem('lang') === "en"? "wiFormCEN": "wiFormC" } >
            <Form
                name="basic"
                form={form}
                autoComplete="off"
                onFinish={onFinish}
                initialValues={{ 
                    country_code_p:'886'
                    // tenant_name: formData.tenant.tenant_name
                    // tenant_name_en: formData.tenant_name_en,
                    // vat_num: formData.vat_num,
                    // duns_num: formData.duns_num,
                    // country: formData.address_data[0].country,
                    // state: formData.address_data[0].state,
                    // city: formData.address_data[0].city,
                    // zip_code: formData.address_data[0].zip_code,
                    // address: formData.address_data[0].address
                }}
                >

                    <Form.Item
                    name="tenant_name"
                    rules={[{ 
                        required: true,
                        message: `${t('Register.Please')}${t('Register.company_name')}`
                    }]}
                    >
                        <Input size='large' disabled prefix={t('Register.company_name')}/>
                    </Form.Item>


                    {IndustryList.map(i=>{
                        return  <Form.Item
                        >
                            <Input size='large' disabled prefix={t('Contact.SectorIndustry')} value={i}/>
                        </Form.Item>
                    })}
                    <Form.Item
                        name="country"
                        rules={[{ 
                            required: true,
                            message: `${t('Register.Please')}${t('Register.country_region')}`
                        }]}
                        >
                        <Input size='large' disabled prefix={t('Register.country_region')}/>
                    </Form.Item>
               
                    <div className='cinfotitle' style={{fontWeight: '600',fontSize: '22px'}}>
                        {t('Contact.Contact')}<span style={{paddingLeft:'20px', fontWeight: '400',fontSize: '16px',lineHeight: '28px',letterSpacing: '0.1em',color: '#7C7C7C'}}>{t('Contact.ContactInformation')}</span>
                    </div>
                        <div className='flexForm'>
                            <Form.Item
                            name="first_name_p"
                            rules={[{ 
                                required: true,
                                message: `${t('Register.Please')}${t('Register.first_name')}`
                            }]}
                            >
                                <Input size='large' prefix={<InputPrefix label={t('Register.first_name')}/>} placeholder={t('Register.da_ming')} />
                            </Form.Item>
                            <div className='block'/>
                            <Form.Item
                            name="last_name_p"
                            rules={[{ 
                                required: true,
                                message: `${t('Register.Please')}${t('Register.last_name')}`
                            }]}
                            >
                                <Input size='large' prefix={<InputPrefix label={t('Register.last_name')}/>} placeholder={t('Register.wang')}/>
                            </Form.Item>
                        </div>
                        <div className='flexForm'>
                            <Form.Item
                            name="position_p"
                            rules={[{ 
                                required: true,
                                message: `${t('Register.Please')}${t('Register.position')}`
                            }]}
                            >
                                <Input size='large' prefix={<InputPrefix label={t('Register.position')}/>}/>
                            </Form.Item>
                            <div className='block'/>
                            <Form.Item
                            name="mobile_phone_p"
                            rules={[{ 
                                required: false,
                                message: `${t('Register.Please')}${t('Register.mobile_phone')}`
                            }]}
                            >
                                <Input size='large' prefix={t('Register.mobile_phone')} placeholder='886 900 000 000'/>
                            </Form.Item>
                        </div>
                        <div className='flexForm'>
                        <Form.Item
                            name="country_code_p"
                            style={{
                                width: '55%',
                            }}
                            rules={[{ 
                                required: true,
                                message: `${t('Register.Please')}${t('Register.CountryCode')}`
                            }]}
                        >
                            <Input maxLength={5} size='large' placeholder={t('Register.CountryNum')} prefix={<InputPrefix label={t('Register.phone')}/>}/>
                        </Form.Item>
                        <Form.Item
                            name="phone_p"
                            style={{
                                width: '50%',
                            }}
                            rules={[{ 
                                required: true,
                                message: `${t('Register.Please')}${t('Register.phone')}`
                            }]}
                            >
                                <Input size='large' placeholder={t('Register.phone')}/>
                            </Form.Item>
                            <div className='block'/>
                            <Form.Item
                            name="ext_number_p"
                            rules={[{ 
                                // required: true,
                                message: `${t('Register.Please')}${t('Register.ext_number')}` 
                            }]}
                            >
                                <Input maxLength={5} size='large' prefix={t('Register.ext_number')}/>
                            </Form.Item>
                        </div>
                        <div className='flexForm'>
                            <Form.Item
                            name="Email_p"
                            rules={[{ 
                                type: "email",
                                required: true,
                                message: `${t('Register.Please')}Email` 
                            }]}
                            >
                                <Input size='large' disabled prefix={<InputPrefix label={'Email'}/>} placeholder='example@mail.com'/>
                            </Form.Item>
                            <div className='block'/>
                            <Form.Item
                            >
                            {/* <div className='dropDowninput'>
                                <div className='title'>
                                    {t('Register.language')}
                                </div>
                                <Select defaultValue={select} value={select} onChange={handleChange}>
                                    <Option value="tw">中文</Option>
                                    <Option value="en">English</Option>
                                </Select>
                            </div> */}
                             </Form.Item>
                        </div>
                        <div className='cinfotitle' style={{fontWeight: '600',fontSize: '22px'}}>
                            <InputPrefix label={t('Contact.Description')}/>
                        </div>
                        <Form.Item
                            name="mail_content"
                            rules={[{ 
                                required: true,
                                message: t('Contact.Input')
                            }]}
                        >
                            <TextArea rows={4} placeholder={t('Contact.Explain')}/>
                        </Form.Item>

                        <div className="wibtnagreeC">
                            <div className='mid'>
                                <div className='btnleft'>
                                <Form.Item>
                                    <Button type="primary" htmlType="submit">{t('Contact.Submit')}</Button>
                                </Form.Item>
                                </div>
                            </div>
                        </div>
                </Form>
                </div>
            </div>
            </Spin>
        </div>
        </>
    )
    }

export default (ContactUs)